import { createSlice } from "@reduxjs/toolkit";

export const userProfile = createSlice({
  name: "userProfile",
  initialState: {
    value: false, // default state
  },
  reducers: {
    // reducers action
    setUserProfile: (state, { payload }) => {
      state.value = payload;
    },
  },
});

export const { setUserProfile } = userProfile.actions;
export default userProfile.reducer;
